import { Lightbulb } from 'lucide-react';
import { t } from '@/i18n';

// Marks a page as a concept: an idea or option for later, not the current focus.
export const ConceptBanner = () => (
  <div className="mb-6 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
    <Lightbulb className="h-4 w-4 mt-0.5 shrink-0" />
    <div>
      <span className="mr-2 rounded-full bg-amber-200/70 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">
        {t('concept.badge')}
      </span>
      {t('concept.hint')}
    </div>
  </div>
);
